import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { authRouterGuard, permissionRouterGuard } from '@/router/guards';
const HomePage = () => import(/* webpackChunkName: 'home' */ '@/components/HomePage.vue');
const ErrorPage = () => import(/* webpackChunkName: 'home' */ '@/components/ErrorPage.vue');

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    component: HomePage,
    meta: {
      isPublic: false
    }
  },
  {
    path: '/error/:code?',
    name: 'errorRoute',
    component: ErrorPage,
    props: true,
    meta: {
      isPublic: true
    }
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach(authRouterGuard);
router.beforeEach(permissionRouterGuard);

export default router;
